import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MasterClientModel } from '@core/model/masterClient.model';
import { CutsProjectModel } from '@core/model/custProject.model';
import { SettingService } from '@shared/service/setting.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-modal-add-user-account',
  templateUrl: './modal-add-user-account.component.html',
  styleUrls: ['./modal-add-user-account.component.scss']
})
export class ModalAddUserAccountComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public registerForm: FormGroup;
  masterClient: MasterClientModel;
  project: CutsProjectModel;
  selectedUserEmail: string = "";
  selectedUserName: string = "";
  emailsAvailable: string[] = [];
  users: any[] = [];
  constructor(
    private settingService: SettingService,
    public dialogRef: MatDialogRef<ModalAddUserAccountComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any)
    {
      if (this.data !== null && this.data !== undefined) {
        this.masterClient = data.masterClient;
        this.project = data.project;
      }
   }

  ngOnInit(): void {
    this.getUsersAndAccountsFromAdmin();
  }

  getUsersAndAccountsFromAdmin() {
    let model = {
      CustAccount: this.masterClient.CustAccount,
      ProjectId: this.project.ProjectId
    };

    this.settingService.GetUsersToRegisterFromAdmin(model)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
    response => {
      if(response !== null) {
        let index = 0;
        this.users = response;
        this.emailsAvailable = [];
        response.forEach(element => {
          this.emailsAvailable.push(element.UserEmail);
        });
      }
    });
  }

  selectUserEmail() {
    this.users.forEach(element => {
      if (element.UserEmail === this.selectedUserEmail) {
        this.selectedUserName = element.Nombre + ' ' + element.Apellido;
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  register() {

    this.users.forEach(element => {
      if (element.UserEmail === this.selectedUserEmail) {
        let model = {
          UserId: element.UserId,
          CustAccount: this.masterClient.CustAccount,
          ProjectId: this.project.ProjectId,
        };

        this.settingService.insertAccountUser(model)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          response => {
            this.dialogRef.close();
          }
        );
      }
    });
  }
}
